import WebApp from '@twa-dev/sdk'
import { getUserProfileFx } from '@/entities/user'
import { goToAuth, goToConnectPlatform } from '@/app/routing/events'
import { getLeaderBoardsFx } from '@/entities/leaderboard/effects'
import { useUnit } from 'effector-react'
import { useState } from 'react'
import { useTonConnectUI } from '@tonconnect/ui-react'
import { $selectedSubscriptionOption, $subscriptionPrices } from '@/entities/payments'
import { $steamId, $userToken } from '@/entities/user'
import { postPurchaseDiscount, postSubscribeToPlatinum, postSubscribeToPlus } from '@/entities/user/api'
import { updatePremiumStatus } from '@/entities/user'

export const useBuySubscription = (handleHide?: () => void) => {
  const subscriptionPrices = useUnit($subscriptionPrices)
  const selectedSubscriptionOption = useUnit($selectedSubscriptionOption)
  const userToken = useUnit($userToken)
  const steamId = useUnit($steamId)
  const [tonConnectUI] = useTonConnectUI()
  const isTonWalletConnected = tonConnectUI.connected
  const [isCreating, setIsCreating] = useState(false)

  const handleBuySubscription = async () => {
    if (!userToken) return goToAuth()
    if (!subscriptionPrices) {
      return WebApp.showAlert('Oops, ask support why there is no subscription plans')
    }
    if (!steamId && !isTonWalletConnected) {
      return goToConnectPlatform({ platform: 'steam' })
    }

    setIsCreating(true)

    try {
      let response

      if (selectedSubscriptionOption === 'platinumDiscount') {
        response = await postPurchaseDiscount(
          userToken,
          subscriptionPrices?.find((option) => option.description === 'platinum')!.id
        )
      } else if (selectedSubscriptionOption === 'platinum') {
        response = await postSubscribeToPlatinum(
          userToken,
          subscriptionPrices?.find((option) => option.description === 'platinum')!.id
        )
      } else {
        response = await postSubscribeToPlus(
          userToken,
          subscriptionPrices?.find((option) => option.description === selectedSubscriptionOption)!.id
        )
      }

      if (response.invoice_url) {
        WebApp.openInvoice(response.invoice_url, (status) => {
          if (status === 'paid') {
            updatePremiumStatus(false)
            getUserProfileFx(userToken)
              .then(() => getLeaderBoardsFx(userToken))
              .finally(() => {
                if (handleHide) {
                  handleHide()
                }
                setIsCreating(false)
              })
          } else {
            setIsCreating(false)
          }
        })
      }
    } catch (err) {
      WebApp.showAlert('Payment failed. Please try again.')
      console.error(err)
    } finally {
      setIsCreating(false)
    }
  }
  return { handleBuySubscription, isCreating }
}
